import { generateBlob, getFile } from "./ExportData";
import { modifyRecordForUpload } from "./DataMapHelper";

export async function generateUpdatedRecordsFile(
  fileContent,
  baseFileName,
  fileType
) {
  if (!fileContent.importRecords?.length) {
    Promise.reject("No records to import");
    return;
  }

  const content = modifyRecordForUpload(fileContent);

  const csvContent = await generateBlob(content, fileType);

  const csvFile = getFile(csvContent, `updated_${baseFileName}`, fileType);

  return csvFile;
}
